import { useEffect, useState, useContext } from "react";
import { navigate } from "@reach/router";
import _ from "lodash";

import { firebaseUpdateUserProfile } from "../firebase/user";
import { firebaseAuthUser } from "../firebase/auth";
import { AppStoreContext } from "../contexts";
import { firebaseMessaging } from "../firebase";

export default function useNotification(props = {}) {
  /**
  |--------------------------------------------------
  | Contexts
  |--------------------------------------------------
  */
  const appStore = useContext(AppStoreContext);

  /**
  |--------------------------------------------------
  | States
  |--------------------------------------------------
  */
  const [loading, setLoading] = useState(true);

  /**
  |--------------------------------------------------
  | Hook
  |--------------------------------------------------
  */

  useEffect(() => {
    async function checkProfile() {
      try {
        const user = await firebaseAuthUser();
        const params = new URLSearchParams(window.location.search);
        const redirect = params.get("redirect");
        if (!user) {
          if (redirect !== null) {
            navigate(`/signin?redirect=${redirect}`);
          } else {
            navigate(`/signin`);
          }

          return;
        }

        firebaseMessaging
          .getToken()
          .then(async (currentToken) => {
            if (currentToken) {
              let updatedUser = {
                token: {
                  web: currentToken,
                },
              };

              await firebaseUpdateUserProfile(user.uid, updatedUser);

              firebaseMessaging.onMessage((payload) => {
                appStore.setNotification(
                  true,
                  payload.notification,
                  _.get(payload, `data['gcm.notification.color']`, "#fff")
                );
              });
            } else {
              console.log(
                "No Instance ID token available. Request permission to generate one."
              );
            }
          })
          .catch((err) => {
            console.log("An error occurred while retrieving token. ", err);
          });

        setLoading(false);
      } catch (error) {
        console.error(error);
      }
    }

    checkProfile();
  }, [appStore]);

  /**
  |--------------------------------------------------
  | Return
  |--------------------------------------------------
  */
  return [loading];
}
